import { mono, monoShared, monoForm } from '@components/systems/monolith/monolith.tokens'
// index 를 거치면 순환 import 로 값이 undefined 가 된다(HomeLayout 과 같은 이유) — 직접 경로
import { MONOLITH_NAV_HEIGHT } from '@components/systems/monolith/MonolithNav'

/**
 * 로그인 후 계정 페이지(My Info · My Order · My Inquiries · Wholesale Orders · Performance ·
 * Change Password · Log out) 공용 스타일. §5 스펙 테이블 문법.
 *
 * 2026-09-26 사용자 결정: 페이지 제목·리드(`.mnAccountHeader`)를 없앴다 — 네비가 어느 페이지인지
 * 이미 말하고 있어 그 아래 큰 제목이 빈 공간만 만들었다. 사이드 네비는 금지라(§5) 이동은
 * 페이지 맨 위 가로 MonolithAccountNav 한 줄이 맡는다.
 */
export const customerAccountStyle = {
	...monoShared,
	...monoForm,
	position: 'relative' as const,
	width: '100%',

	/**
	 * 2026-10-06 가운데 한 칼럼 — 네비 줄과 본문이 같은 760 폭으로 화면 가운데에 선다(왼쪽 선 하나).
	 * 그 전에는 본문만 760 왼쪽 정렬이고 네비 헤어라인은 전폭이라 데스크톱에서 오른쪽 절반이 비었다.
	 * 4:8 밴드 + 왼쪽 설명 문구 안은 사용자가 거절했다. 예외 = Wholesale(표라 전폭, 그 페이지에서 되돌린다).
	 */
	/**
	 * 2026-10-06 짧은 계정 페이지에서 푸터가 화면 중간에 떠 보이던 것 — 본문 칸(.mnWrap)이 최소한
	 * **화면 높이 − 상단 바**를 차지한다. 그래서 첫 화면은 네비 + 본문으로 차고 푸터는 늘 첫 화면 바로 아래에서
	 * 시작한다. 고정값(35rem 등)은 화면 높이마다 결과가 달라 쓰지 않는다. 내용이 더 길면 그대로 늘어난다.
	 * `svh` = 모바일 주소창이 보이는 상태의 높이 — 주소창 때문에 푸터가 첫 화면에 걸치지 않는다. 미지원 브라우저는 vh.
	 */
	// 키를 '.mnWrap' 로 쓰면 monoShared 의 같은 키(좌우 여백 · 최대폭)를 통째로 덮는다 — '& .mnWrap' 로 따로 건다
	'& .mnWrap': {
		minHeight: `calc(100vh - ${MONOLITH_NAV_HEIGHT}px)`,
	},
	'@supports (height: 100svh)': {
		'& .mnWrap': {
			minHeight: `calc(100svh - ${MONOLITH_NAV_HEIGHT}px)`,
		},
	},

	'.mnAccountNav, .mnAccountBody': {
		marginLeft: 'auto',
		marginRight: 'auto',
	},

	/**
	 * 제목이 없어졌으니 네비가 첫 요소다. 2026-10-06 상단 바와의 간격을 없앴다(사용자 지시 "최대한 줄여") —
	 * 네비 안쪽 위아래 여백(22)만 남는다. 예전 값 clamp(40px, 5vw, 72px).
	 */
	'.mnAccountNav': {
		maxWidth: 760,
		marginTop: 0,
	},

	/** 네비 아래 본문. 여백만으로 구분한다 */
	'.mnAccountBody': {
		width: '100%',
		maxWidth: 760,
		padding: 'clamp(48px, 5.5vw, 80px) 0 clamp(64px, 8.3vw, 120px)',
		display: 'flex',
		flexDirection: 'column' as const,
		gap: 40,
	},

	/** 폼·행 아래 동작 줄 — 주 동작 하나(블랙) + 보조는 텍스트 링크 */
	'.mnAccountActions': {
		display: 'flex',
		alignItems: 'center',
		gap: 28,
		flexWrap: 'wrap' as const,
		marginTop: 4,
	},

	/** 조용한 상태 한 줄 (빈 목록·로딩) */
	'.mnAccountQuiet': {
		fontSize: 16,
		fontWeight: 300,
		color: mono.dim,
	},
}
